/* tslint:disable */
/* eslint-disable */
/**
 * Kontor API
 * OpenAPI specification for Kontor application framework
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Errors,
    ErrorsFromJSON,
    ErrorsToJSON,
    EventList,
    EventListFromJSON,
    EventListToJSON,
    EventLocationList,
    EventLocationListFromJSON,
    EventLocationListToJSON,
    EventLocationObject,
    EventLocationObjectFromJSON,
    EventLocationObjectToJSON,
    EventObject,
    EventObjectFromJSON,
    EventObjectToJSON,
    Reservation,
    ReservationFromJSON,
    ReservationToJSON,
    TicketPayment,
    TicketPaymentFromJSON,
    TicketPaymentToJSON,
    TicketPaymentResponse,
    TicketPaymentResponseFromJSON,
    TicketPaymentResponseToJSON,
    TicketPurchase,
    TicketPurchaseFromJSON,
    TicketPurchaseToJSON,
    TicketPurchaseRequest,
    TicketPurchaseRequestFromJSON,
    TicketPurchaseRequestToJSON,
} from '../models';

export interface EventIdGetRequest {
    id: string;
}

export interface EventlocationIdGetRequest {
    id: string;
}

export interface ReservationPostRequest {
    reservation: Reservation;
}

export interface TicketpaymentPostRequest {
    ticketPayment: TicketPayment;
}

export interface TicketpurchasePostRequest {
    ticketPurchaseRequest: TicketPurchaseRequest;
}

/**
 * 
 */
export class EventApi extends runtime.BaseAPI {

    /**
     * Load all events.
     */
    async eventGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<EventList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/event`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventListFromJSON(jsonValue));
    }

    /**
     * Load all events.
     */
    async eventGet(initOverrides?: RequestInit): Promise<EventList> {
        const response = await this.eventGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Load a specific event.
     */
    async eventIdGetRaw(requestParameters: EventIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<EventObject>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling eventIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/event/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventObjectFromJSON(jsonValue));
    }

    /**
     * Load a specific event.
     */
    async eventIdGet(requestParameters: EventIdGetRequest, initOverrides?: RequestInit): Promise<EventObject> {
        const response = await this.eventIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Load all event locations.
     */
    async eventlocationGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<EventLocationList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eventlocation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventLocationListFromJSON(jsonValue));
    }

    /**
     * Load all event locations.
     */
    async eventlocationGet(initOverrides?: RequestInit): Promise<EventLocationList> {
        const response = await this.eventlocationGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Load a specific event location.
     */
    async eventlocationIdGetRaw(requestParameters: EventlocationIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<EventLocationObject>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling eventlocationIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eventlocation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventLocationObjectFromJSON(jsonValue));
    }

    /**
     * Load a specific event location.
     */
    async eventlocationIdGet(requestParameters: EventlocationIdGetRequest, initOverrides?: RequestInit): Promise<EventLocationObject> {
        const response = await this.eventlocationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit a ticket or seat reserveration request.
     */
    async reservationPostRaw(requestParameters: ReservationPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Reservation>> {
        if (requestParameters.reservation === null || requestParameters.reservation === undefined) {
            throw new runtime.RequiredError('reservation','Required parameter requestParameters.reservation was null or undefined when calling reservationPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/vnd.api+json';

        const response = await this.request({
            path: `/reservation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReservationToJSON(requestParameters.reservation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReservationFromJSON(jsonValue));
    }

    /**
     * Submit a ticket or seat reserveration request.
     */
    async reservationPost(requestParameters: ReservationPostRequest, initOverrides?: RequestInit): Promise<Reservation> {
        const response = await this.reservationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send ticket payment result to API service provider to complete online payment of a ticket purchase.
     */
    async ticketpaymentPostRaw(requestParameters: TicketpaymentPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<TicketPaymentResponse>> {
        if (requestParameters.ticketPayment === null || requestParameters.ticketPayment === undefined) {
            throw new runtime.RequiredError('ticketPayment','Required parameter requestParameters.ticketPayment was null or undefined when calling ticketpaymentPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/vnd.api+json';

        const response = await this.request({
            path: `/ticketpayment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketPaymentToJSON(requestParameters.ticketPayment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TicketPaymentResponseFromJSON(jsonValue));
    }

    /**
     * Send ticket payment result to API service provider to complete online payment of a ticket purchase.
     */
    async ticketpaymentPost(requestParameters: TicketpaymentPostRequest, initOverrides?: RequestInit): Promise<TicketPaymentResponse> {
        const response = await this.ticketpaymentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit a ticket purchase request.
     */
    async ticketpurchasePostRaw(requestParameters: TicketpurchasePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<TicketPurchase>> {
        if (requestParameters.ticketPurchaseRequest === null || requestParameters.ticketPurchaseRequest === undefined) {
            throw new runtime.RequiredError('ticketPurchaseRequest','Required parameter requestParameters.ticketPurchaseRequest was null or undefined when calling ticketpurchasePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/vnd.api+json';

        const response = await this.request({
            path: `/ticketpurchase`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketPurchaseRequestToJSON(requestParameters.ticketPurchaseRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TicketPurchaseFromJSON(jsonValue));
    }

    /**
     * Submit a ticket purchase request.
     */
    async ticketpurchasePost(requestParameters: TicketpurchasePostRequest, initOverrides?: RequestInit): Promise<TicketPurchase> {
        const response = await this.ticketpurchasePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
